export const OG_IMAGE_WIDTH = 2400;
export const OG_IMAGE_WIDTH_RESIZE = 1200;
export const OG_IMAGE_HEIGHT = 1254;
